import React, { useState, useEffect } from 'react';
import Auth from 'j-toker';
import styled from 'styled-components';

import { Form, message, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { getTranslatedString } from 'helpers/i18n';

const StyledFormItem = styled(Form.Item)`
  margin-top: 12px;
`;

const beforeUpload = (file) => {
  const isValidFileType = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
  ].includes(file.type);

  if (!isValidFileType) {
    message.error(getTranslatedString('landlordPortal.applicationPackages.form.typeError'));
  }

  const isLt20M = file.size / 1024 / 1024 < 20;
  if (!isLt20M) {
    message.error(
      getTranslatedString('landlordPortal.applicationPackages.form.documentsSizeError')
    );
  }

  return isValidFileType && isLt20M;
};

const DocumentUpload = ({ fieldName }) => {
  const form = Form.useFormInstance();

  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    setFileList(form.getFieldValue(fieldName));
  }, [fieldName]);

  const handleChange = (info) => {
    let newFileList = [...info.fileList];

    if (info.file.status === 'done') {
      // map only responses
      newFileList = [...form.getFieldValue(fieldName), info.file.response?.file_upload];
      form.setFieldsValue({ [fieldName]: newFileList });
    }
    setFileList(newFileList);
  };

  const handleRemove = (fileToRemove) => {
    let newFileList = fileList.filter((file) => file.id != fileToRemove.id);
    form.setFieldsValue({ [fieldName]: newFileList });
    setFileList(newFileList);
  };

  return (
    <>
      <Form.Item name={fieldName} hidden />
      <StyledFormItem
        label={getTranslatedString('landlordPortal.applicationPackages.form.documents')}
      >
        <Upload
          name="upload"
          multiple
          beforeUpload={beforeUpload}
          fileList={fileList}
          action={`${Auth.getApiUrl()}/file_uploads`}
          onChange={handleChange}
          onRemove={handleRemove}
        >
          <Button icon={<UploadOutlined />}>
            {getTranslatedString('landlordPortal.applicationPackages.form.upload')}
          </Button>
        </Upload>
      </StyledFormItem>
    </>
  );
};

export default DocumentUpload;
